import { gql } from '@apollo/client';

export const GENERATE_GOOD_DEAL_ARTICLE_IA = gql`
  mutation GenerateGoodDealArticle($amazonProductUrl: String!) {
    generateGoodDealArticleIA(amazonProductUrl: $amazonProductUrl) {
      processId
    }
  }
`;
